import {
  apiGet,
  apiPut,
  apiDelete,
  apiPost,
} from "../../../utils";

export const getRiskManagementDetailsAPI = (data) => {
  return apiGet("/api/risk-management", data);
};  

export const addRiskManagementDetailsAPI = (data) => {
  return apiPost("/api/risk-management", data);
};

export const updateRiskManagementDetailsAPI = (params, data) => {
  return apiPut(`/api/risk-management/${params.id}`, data);
};

export const deleteRiskManagementDetailsAPI = (id) => {
  return apiDelete(`/api/risk-management/${id}`);
};